
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import SecureLS from 'secure-ls';
import { Account } from '../interfaces/account';
import { Instance } from '../interfaces/instance';
import { ajaxFetcherGet } from '../fetchers';
import { SessionData } from '../interfaces/session-data';
import { InterfaceData } from '../interfaces/interface-data';
import { Language } from '../interfaces/language';

const ls = new SecureLS({ encodingType: 'aes', isCompression: true });

const encryptedSessionStorage = {
    getItem: (key: string) => {
        try {
            const data = ls.get(key);
            return data ? JSON.parse(data) : null;
        } catch (error) {
            return null;
        }
    },
    setItem: (key: string, value: any) => {
        try {
            ls.set(key, JSON.stringify(value));
        } catch (error) {
        }
    },
    removeItem: (key: string) => {
        ls.remove(key);
    }
};


interface StoreState {
    account?: Account
    instance?: Instance
    languages?: Language[]
    defaultLanguage?: Language
    isLoaded: boolean
}

interface StoreActions {
    fetchSession: () => void
    fetchLanguages: () => void
    fetchDefaultSelectedManagers: () => Promise<SelectOption[]>

    refreshSession: () => void
}



export const useAppStore = create<StoreState & StoreActions>((set, get) => ({

    isLoaded: false,

    fetchSession: async () => {
        const myspaceContext = AUTH.frontloginas == 'hotelier' ? 'providers'  : 'clients';
        ajaxFetcherGet({
            url: `${ENV.base_lang_url}myspace/${myspaceContext}//ajaxGetter/get_session`
        }).then((res: SessionData) => {
            set({
                account: res.account, 
                instance: res.instance,
                isLoaded: true
            });
        })
    },

    fetchLanguages: async () => {
        const myspaceContext = AUTH.frontloginas == 'hotelier' ? 'providers'  : 'clients';
        ajaxFetcherGet({
            url: `${ENV.base_lang_url}myspace/${myspaceContext}//ajaxGetter/get_languages`
        }).then((res: Language[]) => {
            set({
                languages: res,
                defaultLanguage: res.find((language) => language.code == ENV.lang)
            });
        })
    },

    fetchDefaultSelectedManagers: async () => {
        if(AUTH.frontloginas == 'hotelier') {
            return ajaxFetcherGet({
                url: `${ENV.base_lang_url}myspace/providers//ajaxGetter/get_default_selected_managers`
            });
        } else null;
    },


    refreshSession: async () => { get().fetchSession() }
}));


window.appRefreshSession = useAppStore.getState().refreshSession;